<div class="manage-categories-dialog-shell vg-dialog-shell">
  <div class="vg-dialog-header">
    <div class="dialog-header__text">
      <h2 mat-dialog-title class="dialog-title">Reorder Categories</h2>
      <p class="dialog-subtitle">
        Drag to reorder how categories appear across Store Management and Version Search
      </p>
    </div>
    <button type="button" mat-icon-button (click)="onCancel()" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="mat-typography manage-categories-dialog vg-dialog-body">
    <p class="categories-meta">
      {{ categories.length }} categor{{ categories.length === 1 ? 'y' : 'ies' }} | Drag to reorder
    </p>

    <div class="categories-list-container" cdkDropList (cdkDropListDropped)="drop($event)">
      <div
        class="category-row"
        *ngFor="let category of categories; let i = index"
        cdkDrag
        [class.category-row--alt]="i % 2 === 1"
        fxLayout="row"
        fxLayoutAlign="space-between center">
        <div class="category-row__start" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
          <mat-icon cdkDragHandle class="drag-handle">drag_indicator</mat-icon>
          <span class="category-dot" [style.background-color]="getCategoryColor(category.color)"></span>
          <span class="category-name">{{ category.name }}</span>
        </div>
        <span class="attribute-type-count">{{ getAttributeTypeCountLabel(category.attributeTypeCount) }}</span>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="sat-dialog-footer">
    <button type="button" class="sat-btn sat-btn--outline" (click)="onCancel()">
      Cancel
    </button>
    <button
      type="button"
      class="sat-btn sat-btn--primary"
      [disabled]="!hasOrderChanged || isSaving"
      (click)="onSave()">
      Save Changes
    </button>
  </mat-dialog-actions>
</div>
